import { TableFieldModel } from '@/model/TableList'
import { printTemplateList } from '@/utils/print'
import { priceWithoutRate } from '@/utils/index'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'title',
    fieldName: '所属公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price',
    width: 120,
    fieldName: '总费用(含税)',
    isMoney: true,
    textAlign: 'right'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price1',
    width: 120,
    fieldName: '总费用(未税)',
    isMoney: true,
    textAlign: 'right',
    convert: context => {
      const { rowData } = context
      const { price } = rowData
      if (!price) {
        return ''
      }
      const { taxRate } = rowData
      return priceWithoutRate(price, true, taxRate)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'taxRate',
    fieldName: '税率',
    formatType: 'percent'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    width: 100,
    fieldName: '报价人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '客户公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyContact',
    fieldName: '联系人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivingEmail',
    fieldName: '邮件接收地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivingAddress',
    fieldName: '收件地址'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'templateName',
    fieldName: '报价单模版名称',
    option: printTemplateList
  }
]
